import React from 'react'
import PropTypes from 'prop-types'
import { getFileIcon } from '../../../../Helpers/DocsViewer/Icons'
import { Subscribe } from 'unstated'
import DocumentsViewerStore from '../../Viewer/Store/DocumentsViewerStore'

const DocumentCard = ({ name, url, type }) => {
  return (
    <Subscribe to={[DocumentsViewerStore]}>
      {({ openDocument }) => (
        <div
          className='documentCard'
          onClick={() => openDocument({ name, url, type })}
        >
          <div className='preview'>
            <div
              className={'icon'}
              style={{
                background: `url(${
                  type && type.includes('image')
                    ? url
                    : getFileIcon(type.toLowerCase())
                }) center center /contain no-repeat `,
              }}
            />
          </div>
          <div className='name'>
            <p>{name}</p>
          </div>
          <a
            href={url}
            rel='noreferrer noopener'
            target='_blank'
            download
            onClick={(e) => e.stopPropagation()}
          >
            {!type.toLowerCase().includes('attachment') && (
              <span className='icon' />
            )}
            {type.toLowerCase().includes('attachment')
              ? 'Open Link'
              : 'Download attachment'}
          </a>
        </div>
      )}
    </Subscribe>
  )
}

export default DocumentCard

DocumentCard.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
}
